/* eslint-disable import/prefer-default-export */
import * as ReduxHelpers from '@src/utils/reduxHelpers'
const prefix = 'cam/compliance/failed.object'

//Action Types

export const DISMISS_PENDING = ReduxHelpers.Types.createActionType(
  prefix,
  'DISMISS_PENDING'
)
export const REMEDIATE_PENDING = ReduxHelpers.Types.createActionType(
  prefix,
  'REMEDIATE_PENDING'
)
